export class DataCatalogBiglakeProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpProjectId",
            "baseName": "gcpProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogMode",
            "baseName": "catalogMode",
            "type": "BiglakeCatalogMode",
            "format": ""
        },
        {
            "name": "defaultLocation",
            "baseName": "defaultLocation",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogBiglakeProperties.attributeTypeMap;
    }
    constructor() {
    }
}
